import { useState } from "react";
import { Filter, X } from "lucide-react";

/**
 * Collapsable filter bar for the performance dashboard. Contains
 * office / operator / source selectors plus the "include Lisboa"
 * toggle. Purely presentational — parent owns the filters state.
 */
export default function FiltersBar({
  filters, setFilters, availableOffices, availableOperators, availableSources,
}) {
  const [open, setOpen] = useState(false);
  const activeCount = [
    filters.office, filters.operator_id, filters.source,
    filters.service_type, filters.status,
  ].filter((v) => v && v !== "").length;

  const setField = (k, v) => setFilters((f) => ({ ...f, [k]: v || "" }));
  const reset = () => setFilters((f) => ({
    ...f, office: "", operator_id: "", source: "", service_type: "", status: "",
  }));

  return (
    <div
      className="bg-card border border-border rounded-xl p-4 flex items-center gap-3 flex-wrap"
      data-testid="filters-bar"
    >
      <div className="flex items-center gap-2 flex-1 flex-wrap">
        <button
          onClick={() => setOpen((o) => !o)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-border text-sm text-foreground hover:bg-muted/40"
          data-testid="filters-toggle"
        >
          <Filter className="w-3.5 h-3.5" />
          Filtros
          {activeCount > 0 && (
            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-foreground text-background text-[10px] font-bold">
              {activeCount}
            </span>
          )}
        </button>

        {open && (
          <>
            <select
              value={filters.office || ""}
              onChange={(e) => setField("office", e.target.value)}
              className="px-3 py-1.5 rounded-lg border border-border text-sm bg-card"
              data-testid="filter-office"
            >
              <option value="">Todos os escritórios</option>
              {availableOffices.map((o) => (<option key={o} value={o}>{o}</option>))}
            </select>

            <select
              value={filters.operator_id || ""}
              onChange={(e) => setField("operator_id", e.target.value)}
              className="px-3 py-1.5 rounded-lg border border-border text-sm bg-card"
              data-testid="filter-operator"
            >
              <option value="">Todos os operadores</option>
              {availableOperators.map((o) => (
                <option key={o.operator_id} value={o.operator_id}>{o.operator_name}</option>
              ))}
            </select>

            <select
              value={filters.source || ""}
              onChange={(e) => setField("source", e.target.value)}
              className="px-3 py-1.5 rounded-lg border border-border text-sm bg-card"
              data-testid="filter-source"
            >
              <option value="">Todas as origens</option>
              {availableSources.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>

            {activeCount > 0 && (
              <button
                onClick={reset}
                className="text-xs text-[hsl(var(--danger))] hover:underline font-semibold flex items-center gap-1"
                data-testid="filter-reset"
              >
                <X className="w-3 h-3" /> Limpar filtros
              </button>
            )}
          </>
        )}
      </div>

      <label className="inline-flex items-center gap-2 text-xs text-muted-foreground cursor-pointer">
        <input
          type="checkbox"
          checked={filters.include_lisboa}
          onChange={(e) => setField("include_lisboa", e.target.checked)}
          data-testid="filter-include-lisboa"
        />
        Incluir fora da área
      </label>
    </div>
  );
}
